module.exports = __webpack_public_path__ + "static/media/logo.c845baef.png";